export default "__VITE_ASSET__ByhcVQN$__"